// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCasesSlide_root__EFd4C","icon":"ClientCasesSlide_icon__jq23s","imageWrapper":"ClientCasesSlide_imageWrapper__bpzkO","text":"ClientCasesSlide_text__8PNs3"};